var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgJson = function SvgJson(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#json_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#json_svg__b)",
    d: "M7.987 11.91c3.54 4.826 7.004-1.347 6.998-5.059C14.98 2.463 10.531.01 7.984.01 3.894.01 0 3.39 0 8.014 0 13.154 4.464 16 7.984 16c-.797-.115-3.451-.683-3.487-6.797-.024-4.134 1.35-5.786 3.48-5.06.049.018 2.352.927 2.352 3.896 0 2.956-2.343 3.871-2.343 3.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#json_svg__c)",
    d: "M7.983 4.14c-2.34-.806-5.205 1.122-5.205 4.983C2.778 15.428 7.45 16 8.017 16 12.106 16 16 12.62 16 7.996 16 2.856 11.536.01 8.017.01c.975-.135 5.254 1.055 5.254 6.904 0 3.814-3.196 5.89-5.274 5.003-.047-.018-2.351-.926-2.351-3.895 0-2.956 2.337-3.882 2.337-3.882Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "json_svg__b",
    x1: 2.366,
    x2: 13.637,
    y1: 2.366,
    y2: 13.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "json_svg__c",
    x1: 13.639,
    x2: 2.368,
    y1: 13.639,
    y2: 2.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "json_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgJson);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;